import Vue from 'vue'
import {
  ticketColumns,
  ticketColumnKeys,
  defaultTicketColumnKeys,
  lockedTicketColumnKeys
} from '../../sharedOptions/ticketsModule'

function sanitizeColumnKeys (keys) {
  if (!Array.isArray(keys) || !keys.length) return null

  const selected = new Set(keys.filter(k => ticketColumnKeys.includes(k)))
  lockedTicketColumnKeys.forEach(k => selected.add(k))

  return ticketColumnKeys.filter(k => selected.has(k))
}

const state = {
  statusFilter: null,
  openStatusFilter: 'open',
  ticketViewFilter: 'requested_tickets',
  sortBy: 'updated_at',
  sortDesc: true,
  visibleColumnKeys: null
}

const getters = {
  visibleFields (state) {
    const keys = state.visibleColumnKeys || defaultTicketColumnKeys
    return ticketColumns.filter(c => keys.includes(c.key))
  }
}

const mutations = {
  setTicketViewFilter (state, newFilter) {
    Vue.set(state, 'ticketViewFilter', newFilter)
  },
  setOpenStatusFilter (state, newFilter) {
    Vue.set(state, 'openStatusFilter', newFilter)
  },
  setStatusFilter (state, newFilter) {
    Vue.set(state, 'statusFilter', newFilter)
  },
  setSortBy (state, newSortBy) {
    Vue.set(state, 'sortBy', newSortBy)
  },
  setSortDesc (state, newSortDesc) {
    Vue.set(state, 'sortDesc', newSortDesc)
  },
  setVisibleColumnKeys (state, keys) {
    Vue.set(state, 'visibleColumnKeys', keys)
  },
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
